import { Injectable } from '@angular/core';
import { PatientPersonalInfo } from '../models/verifypatient/verifypatient';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { DiagnosisSearch, DeleteFamilyHX } from '../models/intake/familyHistory';
import { FamilyHistory } from '../models/intake/familyHistory';

@Injectable({
  providedIn: 'root'
})
export class FamilyHistoryService {

  constructor(private genericService: GenericUtilityService) { }

  getFamilyHistory(personalInfo: PatientPersonalInfo){
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetFamilyHistory?PatientAccount=" + personalInfo.PATIENT_ACCOUNT + '&PracticeCode=' + personalInfo.PRACTICE_CODE);
  }

  getRelationsDropDown(personalInfo: PatientPersonalInfo){
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetIntakeForms?PatientAccount=" + personalInfo.PATIENT_ACCOUNT + '&PracticeCode=' + personalInfo.PRACTICE_CODE);
  }

  getDiagnosis(modelDiagonsis: DiagnosisSearch){
    return this.genericService._httpClient.post("https://smartsearch.mtbc.com/api/talkEHRICDsTenNineSnomedForDoctors/PickICDsTenNineSnomedForDoctors", modelDiagonsis);
  }

  saveUpdateFamilyHistory(data: any){
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SaveFamilyHX", data);
  }

  noKnownFamilyHistory(personalInfo: PatientPersonalInfo){
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SetNoKnownFamilyhistoryForPatient", {PatientAccount: personalInfo.PATIENT_ACCOUNT, PracticeCode: personalInfo.PRACTICE_CODE});
  }

  DeleteFamilyHX(fHX: DeleteFamilyHX){
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "DeleteFamilyHX", fHX);
  }

  GetCommonDisease(patientAccount: any, practiceCode: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetCommonDisease?PatientAccount=" + patientAccount + '&PracticeCode=' + practiceCode);
  }
}
